export const POSSIBLE_ORIGINS = [
  'ionic://localhost',
  'https://localhost',
  'http://localhost',
]

export const DAYS_OF_THE_WEEK = ['日', '月', '火', '水', '木', '金', '土']

export const DATE_FORMAT = 'yyyy.MM.dd'
